import type { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import Axios from 'axios'
import * as QueryString from 'qs'

export function initAxios(baseUrl: string): AxiosInstance {
  const axiosInstance = Axios.create({
    adapter: 'fetch',
    timeout: 60000,
    baseURL: baseUrl,
    paramsSerializer: params => QueryString.stringify(params, { arrayFormat: 'repeat' }),
  })
  axiosInstance.interceptors.request.use((config) => {
    return config
  })
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return response
    },
    async (error: AxiosError) => {
      console.debug('axios failed:', error.isAxiosError ? error.response : error?.stack ?? error)
      return Promise.reject(error)
    },
  )
  return axiosInstance
}
